<template>
  <b-button
    :data-cy="dataCyId"
    type="submit"
    :class="['btn-submit', className, '']"
    :disabled="!isChangeData || isLoading"
  >
    <LottieAnimation
      v-if="isLoading"
      :class="'tw-h-[36px] tw-w-full'"
      :animation-data="ProgressAnimation"
      :auto-play="true"
      :loop="true"
    />
    <span>{{ title }}</span>
  </b-button>
</template>

<script lang="ts" setup>
import ProgressAnimation from "@/assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: true,
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  className: {
    type: String,
    default: "",
  },
  isChangeData: {
    type: Boolean,
    required: false,
    default: false,
  },
  dataCyId: {
    type: String,
    default: "",
  },
});
</script>

<style lang="scss">
.btn-submit {
  height: 36px;
  border-radius: 100px;
  background: var(--brand-dark-sky, #387dff);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
  padding: 0px 20px;
  color: var(--ui-white, #fff);
  text-align: center;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border: 0;
  overflow: hidden;

  &:disabled {
    pointer-events: none;
    background-color: #62a2f5;
    opacity: 1;
  }

  &:hover,
  &:focus,
  &:not(:disabled):not(.disabled):active,
  &:not(:disabled):not(.disabled):active:focus {
    background: #0345bd;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
  }
}
</style>
